import { render, staticRenderFns } from "./SnotifyIcon.vue?vue&type=template&id=444962c7"
import script from "./SnotifyIcon.vue?vue&type=script&lang=js"
export * from "./SnotifyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports